// extracted by mini-css-extract-plugin
module.exports = {"ResumesCards":"ResumesCards_ResumesCards__gz_JH","ResumesCards__showMore":"ResumesCards_ResumesCards__showMore__r48AW"};